import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
const SvgEllipse = (props, ref) => /* @__PURE__ */ jsx("svg", { xmlns: "http://www.w3.org/2000/svg", width: 10, height: 10, viewBox: "0 0 9 9", role: "img", ref, ...props, children: /* @__PURE__ */ jsx("circle", { cx: 4.5, cy: 4.5, r: 4.5, fill: "currentColor" }) });
const ForwardRef = forwardRef(SvgEllipse);
export default ForwardRef;
